import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var Camera01 = function Camera01(props) {
  return /*#__PURE__*/_jsxs("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props, {
    children: [/*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M2 8.3772c0-.3503 0-.5255.0146-.673.141-1.423 1.2667-2.5486 2.6896-2.6896C4.8517 5 5.0364 5 5.4056 5c.1423 0 .2134 0 .2738-.0037A2 2 0 0 0 7.414 3.746c.0226-.0561.0437-.1194.0859-.246s.0633-.1899.0859-.246a2 2 0 0 1 1.7347-1.2503C9.381 2 9.4477 2 9.5811 2h4.8378c.1334 0 .2001 0 .2605.0037a2 2 0 0 1 1.7347 1.2503c.0226.0561.0437.1194.0859.246s.0633.1899.0859.246a2 2 0 0 0 1.7347 1.2503C18.381 5 18.4521 5 18.5944 5c.3692 0 .5539 0 .7014.0146 1.4229.141 2.5486 1.2667 2.6896 2.6896.0146.1475.0146.3227.0146.673V16.2c0 1.6802 0 2.5202-.327 3.162a3 3 0 0 1-1.311 1.311C19.7202 21 18.8802 21 17.2 21H6.8c-1.6802 0-2.5202 0-3.162-.327a3 3 0 0 1-1.311-1.311C2 18.7202 2 17.8802 2 16.2z"
    }), /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M12 16.5c2.2091 0 4-1.7909 4-4s-1.7909-4-4-4-4 1.7909-4 4 1.7909 4 4 4"
    })]
  }));
};
export default Camera01;